import { reactive, ref } from '@nuxtjs/composition-api';
import Cookies from 'js-cookie';
import { YANDEX_METRIKA_ID } from '~/plugins/yandexMetrika';
const mutationObserver = ref();
function defineTests(options) {
    return reactive(options);
}
/**
 * Список тестов, например:
 * abSomeTest: 'a' as 'a' | 'b' | 'c',
 */
const tests = defineTests({
    recommendationSystem: 'a',
});
async function initUserSplit(route) {
    let uaasCuid = Cookies.get('user_id');
    const ymab = Cookies.get('_ymab_param') || '';
    if (!uaasCuid) {
        uaasCuid = Math.random().toString(36).slice(2, 12);
        Cookies.set('uaas_id', uaasCuid, { path: '/', expires: 365 });
    }
    const params = new URLSearchParams({
        client_id: `metrika.${YANDEX_METRIKA_ID}`,
        url: process.client ? location.href : route.fullPath,
        cuid: uaasCuid,
    });
    if (ymab) {
        params.set('i', ymab);
    }
    const res = await fetch(`https://uaas.yandex.ru/v1/exps?${params.toString()}`);
    const data = res.ok ? await res.json() : null;
    if (data?.i && !ymab) {
        Cookies.set('_ymab_param', data.i, { path: '/', expires: 365 });
    }
    return data;
}
export function useABTest() {
    return {
        get tests() {
            return tests;
        },
        async init(el, route) {
            const testsKeys = Object.keys(this.tests);
            if (!testsKeys.length) {
                return;
            }
            for (const key of testsKeys) {
                el.dataset[key] = this.tests[key];
                if (key in route.query) {
                    this.tests[key] = el.dataset[key] = route.query[key];
                }
                const uaasData = await initUserSplit(route);
                const foundFlag = uaasData?.flags?.find((flag) => flag.n === key);
                if (foundFlag) {
                    this.tests[key] = el.dataset[key] = foundFlag.v;
                }
            }
            mutationObserver.value = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes') {
                        const target = mutation.target;
                        for (const key of testsKeys) {
                            this.tests[key] = target.dataset[key]?.toLowerCase();
                        }
                    }
                }
            });
            mutationObserver.value.observe(el, {
                attributes: true,
            });
        },
    };
}
